import axios from "axios";

export const getVezgoUserToken = async (
  accountId: string
): Promise<{ token: string }> => {
  const { data } = await axios.post(`/accounts/${accountId}/vezgo-user-token`);
  return data;
};
